if (!customElements.get('section-collection')) {
  class TG_SectionCollection extends HTMLElement {
    constructor() {
      super();
      this.isLoading = false;
    }
    
    connectedCallback() {
      if (window.themegoal && themegoal.components_business && themegoal.components_business.filter_products) {
          new themegoal.components_business.filter_products.FilterProducts(this);
      }
      
      this.initInfiniteScroll();
    }

    initItemAnimations(elements) {
      if (!elements || elements.length === 0) return;

      const cardObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            const item = entry.target;
            const animateItem = item.querySelector('.Animate__Item') || (item.classList.contains('Animate__Item') ? item : null);

            if (animateItem) {
              setTimeout(() => {
                animateItem.style.transition = "transform 0.8s ease, opacity 0.9s ease 0.1s";
                animateItem.style.opacity = "1";
                animateItem.style.transform = "translateY(0px)";
              }, index * 300);
            }
            cardObserver.unobserve(item);
          }
        });
      }, { threshold: 0.3 });

      elements.forEach((el) => {
        const animateItem = el.querySelector('.Animate__Item') || (el.classList.contains('Animate__Item') ? el : null);
        if (animateItem) {
          if (getComputedStyle(animateItem).opacity == "0") {
            animateItem.style.opacity = "0";
            animateItem.style.transform = "translateY(50px)";
            cardObserver.observe(el);
          }
        }
      });
    }

    initInfiniteScroll() {
      const loader = this.querySelector('.InfiniteScroll__Loader');
      if (!loader) return;

      const options = {
        rootMargin: '0px 0px 1000px 0px',
        threshold: 0
      };

      if (this.infiniteObserver) this.infiniteObserver.disconnect();

      this.infiniteObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isLoading) {
            console.log('Loader in view, fetching next page...');
            this.loadNextPage();
          }
        });
      }, options);

      this.infiniteObserver.observe(loader);
    }

    loadNextPage() {
      const nextLink = this.querySelector('#PaginationContainer .Pagination__Link--next');
      
      if (!nextLink || this.isLoading) {
        if (!nextLink) this.querySelector('.InfiniteScroll__Loader')?.remove();
        return;
      }

      this.isLoading = true;

      fetch(nextLink.href)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newElements = html.querySelectorAll('#ProductGridContainer .Grid__Item');
          const gridResults = this.querySelector('#ProductGridContainer');
          const newPagination = html.querySelector('#PaginationContainer');

          if (newElements.length && gridResults) {
            newElements.forEach(el => gridResults.appendChild(el));
            this.initItemAnimations(newElements);
          }

          const currentPagination = this.querySelector('#PaginationContainer');
          if (newPagination && currentPagination) {
            currentPagination.innerHTML = newPagination.innerHTML;
          }

          this.isLoading = false;

          if (!html.querySelector('.Pagination__Link--next')) {
            this.querySelector('.InfiniteScroll__Loader')?.remove();
            this.infiniteObserver.disconnect();
          } else {}

          window.dispatchEvent(new Event('scroll'));
        })
        .catch(error => {
          console.error('Fetch error:', error);
          this.isLoading = false;
        });
    }
  }
        
  customElements.define('section-collection', TG_SectionCollection);
}